import { useEffect, useRef, useState } from 'react';
import Image from 'next/image';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';


const ServicesHWW = ({items, title, text, aftertext}) => {

  const [currentActiveIndex, setCurrentActiveIndex] = useState(0)
  const sectionRef = useRef(null)
  const titleRef = useRef(null)
  const textRef = useRef(null)
  const bottomText = useRef(null)
  const containerRef = useRef(null)


  useGSAP(()=> {
    const mm = gsap.matchMedia();

    mm.add("(min-width: 1280px)", () => {

        gsap.fromTo(containerRef.current, {
          y: '13rem'
        },
            {
          y: 0,
          ease: "none",
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top bottom", 
            end: "top 60%",  
            scrub: 0.1,  
          },
        });


      gsap.fromTo(titleRef.current, { opacity: 0 }, {
        opacity: 1,

        duration: 1,
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 70%",
        },
      });

      gsap.fromTo(bottomText.current, { opacity: 0 }, {
        opacity: 1,
        duration: 1,
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 20%",
        },
      });

      gsap.fromTo(textRef.current, { opacity: 0 }, {
        opacity: 1,

        duration: 1,
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 70%",
        },
      });

    if (sectionRef.current)  {
        const itemsEls = gsap.utils.toArray(".hww-item");
  
        gsap.from(itemsEls, {
          opacity: 0,
          y: '2rem',
          duration: 0.9,
          stagger: 0.15,
          ease: "power1.out",
          scrollTrigger: {
            trigger: sectionRef.current,
            // markers: true,
            start: "top 50%",
            end: "bottom 20%",
          },
        });
    }


    });

    return () => mm.revert();
  }, {scope: sectionRef});


  useEffect(()=> {
    setTimeout(()=> {
      ScrollTrigger.refresh();
    }, 700)
  }, [currentActiveIndex])

  return (
    <section ref={sectionRef} className="container-max overflow-hidden py-[4rem]  md:py-[5rem] lg:pb-[15rem] xl:pb-[18rem] container-padding lg:py-[6rem] xl:py-[8rem] w-full relative ">
      <div ref={containerRef} className=''>

        <div className='mb-[3.2rem]  md:mb-[4rem] flex-col  container-grid lg:mb-[15rem] xl:mb-[19rem]'>
          <h2 ref={titleRef} className='heading-3 md:col-span-5 mb-[1.6rem] lg:col-span-4 lg:col-start-2 lg:mb-0 text-left lg:mr-0 mr-auto lg:text-right md:mb-[2rem] [&>.selected]:italic [&>.selected]:text-dusty-green-dark' dangerouslySetInnerHTML={{__html: title}}/>
          <p ref={textRef} className='lg:mt-[0.8rem] xl:mt-[1.4rem] text-1 md:col-span-5 lg:col-span-4 lg:col-start-7 mr-auto'>{text}</p>
        </div>

        <div className='w-full mb-[2.4rem] flex-flex-col'>
          {items?.map((item, index)=> <div key={index} onClick={() => setCurrentActiveIndex(currentActiveIndex === index ? null : index)} className={`outline-none group cursor-pointer text-left hww-item py-[2rem] lg:py-[3.2rem] flex relative justify-between  border-b-[1px]   w-full  ${
                index === currentActiveIndex ? 'border-dusty-blue' : 'border-dusty-blue-10'
              }`}>
                <div className='w-full relative'>
                <div  className=' outline-none  relative flex w-full  justify-between lg:justify-start items-start'>
                  <div className='flex items-center relative pl-[4rem] md:pl-0'>
                    <span className={`${currentActiveIndex === index ? 'md:bg-dusty-pink-light' : ''} heading-4 md:font-light md:font-inter text-[1.8rem] md:text-[1.4rem] xl:text-[1.6rem] md:opacity-100 md:w-[4rem] md:h-[4rem] md:border-dusty-pink-light md:border-[1px] absolute md:relative left-0 top-0 flex items-center justify-center rounded-full  mr-[1.6rem] opacity-20`}>{'0' + (index + 1)}</span>
                    <h3 className='heading-4 text-wrap lg:max-w-[32rem] xl:max-w-[50rem] text-left'>{item.title}</h3>
                  </div>
                  <div className="p-[1rem] lg:pt-[1.7rem] pl-0 ml-[1.6rem] lg:p-0 ">
                  <svg
                      className={`${currentActiveIndex === index ? "rotate-180 lg:opacity-100" : "lg:rotate-270 lg:group-hover:opacity-100 lg:opacity-0"} transition-[rotate,opacity] duration-300 ml-[1.2rem]`}
                      width="15"
                      height="8"
                      viewBox="0 0 15 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1 1.5L7.5 6.5L14 1.5"
                        stroke="CurrentColor"
                        strokeWidth="1.3"
                      />
                    </svg>



                    <div  className={`hidden absolute lg:block top-1/2 -translate-y-1/2 right-0 ${currentActiveIndex === index ? 'opacity-0' : 'opacity-0 group-hover:opacity-100'} ease-out transition-opacity duration-500 lg:block  h-[9rem]  aspect-[1.57] `}>
                      <Image
                        src={item.image.url}
                        alt={item.image?.alt}
                        fill
                      
                        sizes="300px"
                        className="w-auto object-cover"
                      />
                    </div>

                    </div>
                </div>

                <div  className={`hidden absolute xl:left-[54.2%] lg:left-1/2 lg:-translate-x-1/2 xl:translate-x-0 top-1/2 -translate-y-1/2 ${currentActiveIndex === index ? 'opacity-100' : 'opacity-0'} transition-opacity duration-500 lg:block  xl:w-[36.6rem] lg:w-[32rem] aspect-[0.73] `}>
                  <Image
                    src={item.image.url}
                    alt={item.image?.alt}
                    fill
                    
                    sizes="600px"
                    className="w-auto object-cover"
                  />
                </div>

                <div className={`${currentActiveIndex === index ? 'max-h-[85rem]' : 'max-h-0'} lg:max-w-[41rem]  xl:max-w-[72rem] transition-[max-height] duration-500 w-full pl-[4rem] md:pl-[6rem] overflow-hidden`}>
                  <div className='pt-[1rem]'>
                    <div className='flex flex-col w-full gap-[1.6rem]'>{item.text.map((text, i)=> <p className='text-1 md:max-w-[60rem]   xl:max-w-[72rem]' key={i + 'text'}>{text.text}</p>)}</div>
                    {item.list ? <div className={`mt-[2rem]`}>
                      {item.list.map((listItem, i)=> <div className={`${listItem.title ? 'mt-[2rem]' : 'mt-0'}  pl-[0.8rem]`} key={'list' + i}>
                        {listItem.title ?                       <h4 className='heading-5 normal-case relative pl-[1.2rem] mb-[0.8rem]'>
                          <span className='absolute left-0 top-1/2 -translate-y-1/2 w-[0.4rem] h-[0.4rem] bg-dark-blue'/>
                          {listItem.title}
                        </h4> : null}
                        {listItem.text ? <p className='relative text-1 mb-[0.8rem] md:max-w-[60rem]  xl:max-w-[60rem] lg:max-w-[35rem]'>
                          {listItem.text}<span className={`${listItem.title ? 'hidden' : 'block'} rounded-full absolute -left-[1.5rem] top-[0.6rem]  w-[0.4rem] h-[0.4rem] bg-dark-blue`}/>
                        </p> : null}

                        <p className='text-1 italic opacity-60'>{listItem.time}</p>
                      </div>)}
                    </div> : null}
                  <div  className="hidden lg:hidden mt-[2.4rem] w-[41.9rem] relative md:block  aspect-[1.5] ">
                    <Image
                      src={item.image.url}
                      alt={item.image?.alt}
                      fill
                      sizes="500px"
                      className="w-auto object-cover"
                    />
                  </div>
                    <div className='lg:hidden mt-[2rem]'>
                      <span className={` mt-[2rem] h-fit font-inter text-dusty-blue-light  font-light ${item.time ? 'md:text-[11.2rem] text-[6.8rem] leading-[80%]' : ''}`}>{item.time} <span className='text-[1.8rem]  font-inter font-medium'>{item.time_small}</span></span>
                    </div>
                  </div>
                </div>

                </div>
                <div className={`hidden ${index === currentActiveIndex ? 'opacity-100' : 'opacity-0'} transition-opacity lg:block`}>
                        <span className={`  ${item.time ? 'leading-[60%] whitespace-nowrap md:text-[11.2rem] text-[6.8rem] top-[3.2rem]' : 'top-[3.2rem] max-w-[21.7rem]'} absolute left-[64%] xl:left-[77%]  h-fit font-inter text-dusty-blue-light  font-light`}>{item.time} <span className='text-[1.8rem]  font-inter font-medium'>{item.time_small}</span></span>
                </div>
          </div>)}
        </div>
        <p ref={bottomText} className='text-1 mt-[2rem] lg:mt-[3.2rem] max-w-[44.7rem] lg:text-left lg:max-w-[45.8%]'>{aftertext}</p>
      </div>
    </section>
  );
};

export default ServicesHWW;